<template>
  <div>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.title"
      clearable
      placeholder="请输入名称"
    ></el-input>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.ali_template_id"
      clearable
      placeholder="请输入阿里短信模板CODE"
    ></el-input>
    <el-select
      class="search-el"
      size="mini"
      v-model="query.type"
      placeholder="类型"
      clearable
      filterable
    >
      <el-option label="全部" value="-1"></el-option>
      <el-option label="验证码" value="1"></el-option>
      <el-option label="通知" value="2"></el-option>
      <el-option label="营销推广" value="3"></el-option>
    </el-select>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.content"
      clearable
      placeholder="请输入短信内容"
    ></el-input>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.status"
      placeholder="状态"
      clearable
      filterable
    >
      <el-option label="全部" value="0"></el-option>
      <el-option label="已上架" value="1"></el-option>
      <el-option label="未上架" value="2"></el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>
    <el-button type="primary" size="mini" @click="toCreate()"> 添加</el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column label="模板ID" align="center" min-width="5%" prop="id">
        </el-table-column>
        <el-table-column
          prop="title"
          label="名称"
          align="center"
          min-width="12%"
        >
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="toCreate(row)">
              <div>{{ row.title }}</div>
            </el-button>
        </template>
      </el-table-column>

        <el-table-column
          prop="ali_template_id"
          label="阿里模板CODE"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          label="内容"
          align="center"
          min-width="25%"
          prop="content"
        >
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a;"
                ><i class="el-icon-circle-check"></i> 已上架</span
              >
              <span v-else style="color: #909399;"
                ><i class="el-icon-circle-close"></i> 未上架</span
              >
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px;"
                @click="
                  row.status == 1
                    ? updateStatus(row.id, 0)
                    : updateStatus(row.id, 1)
                "
              >
                {{ row.status == 1 ? "下架" : "发布" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="创建时间"
          align="center"
          min-width="12%"
          prop="created_at"
        >
        </el-table-column>
        <el-table-column
          label="创建人"
          align="center"
          min-width="12%"
          prop="admin_name"
        >
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.args_count == 0"
              type="primary"
              size="mini"
              @click="
                send.dialogVisible = true;
                send.id = row.id;
                send.content = row.content;
                send.title = row.title;
                send.has_at = true;
              "
            >
              定时
            </el-button>
            <el-button
              v-if="row.args_count == 0"
              type="primary"
              size="mini"
              @click="
                send.dialogVisible = true;
                send.id = row.id;
                send.content = row.content;
                send.title = row.title;
                send.has_at = false;
              "
            >
              群发
            </el-button>
            <el-button v-if="row.id > 10000" type="danger" size="mini" @click="del(row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="短信模板"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="tempReset"
      :show-close="false"
      width="70%"
    >
      <el-form
        :model="topicTemp"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="topicTemp.type">
            <el-radio label="2">通知</el-radio>
            <!-- <el-radio label="3">营销推广</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="阿里模板">
          <el-input
            v-model="topicTemp.ali_template_id"
            maxlength="13"
            show-word-limit
            placeholder="请输入阿里短信模板CODE"
          ></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="title">
          <el-input
            v-model="topicTemp.title"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 15 }"
            v-model="topicTemp.content"
            maxlength="140"
            show-word-limit
          ></el-input>
          <div>
            变量格式：${code}；例如：您的验证码为 ${code}
            ，该验证码5分钟内有效，请勿泄露于他人。
          </div>
          <el-tooltip
            class="item"
            effect="dark"
            content='短信字数含"签名+模版内容+变量内容”，短信70个字数含以内，按1条短信计费；超出70个字为长短信，按照67个字数记为1条短信费用。'
            placement="right"
          >
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="dialogVisible = false; tempReset()"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            :loading="updateLoading"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="发送短信"
      :visible.sync="send.dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="70%"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称" prop="title">
          <el-input v-model="send.title" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="发送内容">
          <el-input
            type="textarea"
            :disabled="true"
            :autosize="true"
            v-model="send.content"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="send.has_at" label="发送时间">
        <el-date-picker
          v-model="send.send_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-value="currentTime"
          placeholder="选择发送时间"
        >
        </el-date-picker>
      </el-form-item>
        <el-form-item label="手机号">
          <el-input
            type="textarea"
            :autosize="true"
            v-model="send.to"
          ></el-input>
          <div>
            1个或多个手机号（每行一个手机号）。
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            @click="
              send.dialogVisible = false;
              send.to = '';
            "
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            :loading="updateLoading"
            @click="sendSms"
            >发送</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSmsTempList,
  createTemplate,
  updateStatus,
  del,
  sendSms,
} from "@/api/sms";

export default {
  data: function () {
    return {
      admin_id: this.$route.query.admin_id,
      currentTime: new Date(), // 获取当前时间
      dialogVisible: false,
      updateLoading: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        title: "",
        type: "",
        ali_template_id: "",
        content: "",
        status: "",
        page: 1,
        limit: 20,
      },

      topicTemp: {
        id: 0,
        ali_template_id: "",
        type: "3",
        title: "",
        content: "",
      },

      rules: {
        type: [
          { required: true, message: "请选择短信类型", trigger: "change" },
        ],
        title: [{ required: true, message: "请输入短信名称", trigger: "blur" }],
        content: [
          { required: true, message: "请输入短信内容", trigger: "blur" },
          { max: 140, message: "最多不超过140个字符", trigger: "blur" },
        ],
      },

      send: {
        dialogVisible: false,
        content: "",
        title: "",
        id: 0,
        to: "",
        send_at: "",
        has_at: false,
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        //if (this.topicTemp.type == '3' && this.topicTemp.content.indexOf("拒收请回复R") == -1) {
        //    this.$message.error('内容中需包含"拒收请回复R"，方可创建成功！')
        //    return false
        //}

        if (valid) {
          console.log(this.topicTemp);
          this.updateLoading = true;
          createTemplate(this.topicTemp)
            .then((response) => {
              this.updateLoading = false;
              if (response.status === "2000") {
                this.dialogVisible = false;
                this.tempReset();
                this.$message.success(response.message);
                this.getList();
              }
            })
            .catch((err) => {
              this.updateLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    tempReset() {
      this.topicTemp = {
        id: 0,
        type: "3",
        ali_template_id: "",
        title: "",
        content: "",
      };
    },
    toCreate(row = null) {
      console.log(row);
      if (row != null) {
        this.topicTemp = {
          id: row.id,
          type: row.type.toString(),
          ali_template_id: row.ali_template_id,
          title: row.title,
          content: row.content,
        };
      }
      this.dialogVisible = true;
    },
    getList() {
      this.loading = true;
      getSmsTempList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateStatus(id, status) {
      updateStatus({
        id: id,
        status: status,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },

    sendSms() {
      this.send.to = this.send.to.trim();
      if (this.send.to == "") {
        this.$message({
          showClose: true,
          message: "请输入目标手机号",
          type: "error",
        });
        return false;
      }

      let phoneReg = /^1[3456789]\d{9}$/; 
      let arr = this.send.to.split(/\n/);
      for (let i = 0; i < arr.length; i++) {
        let phone = arr[i];console.log(phone)
        if (phone == '') {
          this.$message.error((i+1) + ' 行手机号验证是空，请删除后发送！')
          return false;
        }
        if (!phoneReg.test(phone.toString())) {
          this.$message.error(phone + ' 手机号验证有误，请修改后发送！')
          return false;
        }
      }

      sendSms({
        id: this.send.id,
        to: this.send.to.replace(/\n/g, ','),
        send_at: this.send.send_at,
      }).then((response) => {
        if (response.status == 2000) {
          this.send.dialogVisible = false;
          this.send.to =  this.send.send_at = "";
          this.getList();
          this.$message({
            showClose: true,
            message: "已提交发送",
            type: "success",
          });
        }
      });
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        del({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          }
        });
      });
    },
  },
  mounted() {},
};
</script>
